import React, { useState } from 'react';
import { authService } from '../services/api';

export default function RegisterForm({ onSuccess, onSwitch }) {
  const [nom, setNom] = useState('');
  const [telephone, setTelephone] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [region, setRegion] = useState('bamako');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.inscription({
        nom_complet: nom,
        telephone,
        mot_de_passe: motDePasse,
        region,
      });
      if (onSuccess) onSuccess();
    } catch (err) {
      setError(err.message || 'Échec de l’inscription');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ag-auth-page">
      <div className="ag-card ag-auth-card">
        <div className="ag-auth-header">
          <div className="ag-auth-badge">✨</div>
          <div>
            <h2>Créer un compte</h2>
            <p className="ag-login-note">Rejoignez AgroShop pour gérer vos commandes, vos stocks ou vos ventes depuis une interface claire et moderne.</p>
          </div>
        </div>

        <form className="ag-form" onSubmit={handleSubmit}>
          <label>
            Nom complet
            <input
              type="text"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              placeholder="Nom et prénom"
              required
            />
          </label>

          <label>
            Téléphone
            <input
              type="text"
              value={telephone}
              onChange={(e) => setTelephone(e.target.value)}
              placeholder="76000000"
              required
            />
          </label>

          <label>
            Mot de passe
            <input
              type="password"
              value={motDePasse}
              onChange={(e) => setMotDePasse(e.target.value)}
              placeholder="Mot de passe"
              required
            />
          </label>

          {/* no persistent remember-me: we use HttpOnly cookie for refresh token and in-memory access token */}

          <label>
            Région
            <select value={region} onChange={(e) => setRegion(e.target.value)}>
              <option value="bamako">Bamako</option>
              <option value="koulikoro">Koulikoro</option>
              <option value="sikasso">Sikasso</option>
              <option value="segeliba">Segou</option>
              <option value="mopti">Mopti</option>
              <option value="gao">Gao</option>
              <option value="kayes">Kayes</option>
            </select>
          </label>

          {error && <div className="ag-alert ag-alert-error">{error}</div>}

          <button className="ag-btn ag-auth-submit" type="submit" disabled={loading}>
            {loading ? 'Inscription...' : 'Créer mon compte'}
          </button>
        </form>

        <div className="ag-form-footer ag-auth-footer">
          <span>Vous avez déjà un compte ?</span>
          <button type="button" className="ag-btn-secondary" onClick={onSwitch}>
            Se connecter
          </button>
        </div>
      </div>
    </div>
  );
}
